import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  ImageField,
  BooleanField,
  NumberField,
} from 'react-admin';

const filters = [<SearchInput source='name' alwaysOn />];

export default function ResourceList(props: any) {
  return (
    <List {...props} filters={filters}>
      <Datagrid rowClick='edit'>
        <NumberField source='id' />
        <TextField source='name' />
        <TextField source='email' />
        <TextField source='personalNumber' />
        <BooleanField source='isActive' />
        <TextField source='telephone' />
      </Datagrid>
    </List>
  );
}
